// This file should only contain action type constants.

export const SET_DEALER_NAME = 'SET_DEALER_NAME';
export const SET_REVIEWS = 'SET_REVIEWS';
export const SET_PAGE_INFO = 'SET_PAGE_INFO';
export const SET_FILTERS = 'SET_FILTERS';
export const SET_SORT = 'SET_SORT';
